import { Link as ScrollLink, Element } from 'react-scroll';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import logo from '../moodmealslogo.png';
import cart1 from "../assets/icons/Fast Cart.png";
import user1 from "../assets/icons/User.png";

// import Spinach from "../assets/images/Spinach and Egg Breakfast Wrap.png";
// import smoothie from "../assets/images/smoothie.png";
// import avocado from "../assets/images/avocado toast.png";
// import Quinoa from "../assets/images/Quinoa Salad.png";
// import SalmonBowl from "../assets/images/Salmon Bowl.png";
// import Blueberry from "../assets/images/Blueberry Oatmeal.png";
// import Banana from "../assets/images/Banana Smoothie.png";
// import Apple from "../assets/images/Apple & Nut Snack.png";
// import QuinoaSalad from "../assets/images/Quinoa Salad with Spinach and Walnuts.png";
// import SalmonRoasted from "../assets/images/Salmon with Roasted Sweet Potatoes and Avocado.png";
// import SpinachEgg from "../assets/images/Spinach and Egg Breakfast Wrap.png";
// import Turmeric from "../assets/images/Turmeric Golden Milk.png";
// import Citrus from "../assets/images/Citrus and Almond Salad.png";
// import Butternut from "../assets/images/Butternut Squash Soup.png";
// import Brown from "../assets/images/Brown Rice and Turkey Stir Fry.png";
// import Berry from "../assets/images/Berry and Greek Yogurt Parfait.png";
// import Spicy from "../assets/images/Spicy Chickpea and Avocado Wrap.png";
// import Salmon from "../assets/images/Salmon and Walnut Salad.png";

import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";
import '../styles/ShopPage.css';

const CategoryPage=({user,onLogout,logoutSuccess,setLogoutSuccess})=>{

  // const getRandomImage=()=>{
  //   const genders=[
  //       Spinach,
  //       Turmeric,
  //       Citrus,
  //       Butternut,
  //       Brown,
  //       Berry,
  //       Spicy,
  //       Salmon,
  //       smoothie,
  //       avocado,
  //       Quinoa,
  //       SalmonBowl,
  //       Blueberry,
  //       Banana,
  //       Apple,
  //       QuinoaSalad,
  //       SalmonRoasted,
  //       SpinachEgg
  //   ];
  //   return genders[Math.floor(Math.random()*genders.length)];
  // };
  // console.log(getRandomImage());

  const [products,setProducts]=useState([]);
  const [filteredProducts,setFilteredProducts]=useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  // const [isMenuOpen,setIsMenuOpen]=useState(false);
  const [isLoading,setIsLoading]=useState(true);
  const [isDropdownOpen,setIsDropdownOpen]=useState(false);
  const navigate=useNavigate();
  const dropdownRef=useRef(null);

  useEffect(()=>{
    setTimeout(()=>{
      setIsLoading(false);
    },2000);
  },[]);

  useEffect(()=>{
    if(logoutSuccess){
        setIsLoading(true);
        setTimeout(()=>{
            setIsLoading(false);
            setLogoutSuccess(false);
            navigate('/');
        }, 2000);
    }
  },[logoutSuccess,navigate,setLogoutSuccess]);

  useEffect(()=>{
    axios.get(`/api/getProducts`)
    .then(res=>{
        setProducts(res.data.products);
        setFilteredProducts(res.data.products);
    })
    .catch(err=>{
        console.error('Something went wrong',err);
    })
  },[]);

  const handleSearch=(e)=>{
    e.preventDefault();
    const filtered=products.filter(element=>element.prod_name.toLowerCase().includes(searchQuery.toLowerCase()));
    setFilteredProducts(filtered);
  };

  const handleAddToCart=(e,id,img,name,price)=>{
    e.preventDefault();
    if(user===null){
        navigate('/login');
        return;
    }
    const cart={
      prod_Id: id,
      cart_img: img,
      cart_name: name,
      cart_boxsize: 'Small',
      cart_dietpref: 'None',
      cart_ingre: '',
      cart_qty: 1,
      cart_itemprice: price
    }
    axios.post(`/api/user/addToCart`,cart,{withCredentials: true})
    .then(res=>{
        console.log('Item added to cart');
    })
    .catch(err=>{
        console.log("Error adding this item:",err);
    });
  };

  const handleBuyNow=(e,id,img,name,price)=>{
    e.preventDefault();
    if(user===null){
        navigate('/login');
        return;
    }
    const cart={
      prod_Id: id,
      cart_img: img,
      cart_name: name,
      cart_boxsize: 'Small',
      cart_dietpref: 'None',
      cart_ingre: '',
      cart_qty: 1,
      cart_itemprice: price
    }
    axios.post(`/api/user/buyNow`,cart,{withCredentials: true})
    .then(res=>{
        navigate('/your-cart');
    })
    .catch(err=>{
        console.log("Error adding this item:",err);
    });
  };

  // const toggleMenu=()=>{
  //   setIsMenuOpen(!isMenuOpen);
  // };

  const toggleUser=()=>{
      setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside=(e)=>{
    if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
        setIsDropdownOpen(false);
    }
  };

  useEffect(()=>{
      document.addEventListener('mousedown',handleClickOutside);
      return()=>{
          document.removeEventListener('mousedown',handleClickOutside);
      };
  },[]);

  return (
    <>
      {isLoading?(
        <div className="loadingContainer">
            <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
        </div>
      ):(
      <>
        <header className="categ-wrapper">
          <div className="categ-mainbar">
            <div className="categ-dropdown-menu">
              {/* <button className="categ-menu-toggle" onClick={toggleMenu}>
                  ☰
              </button> */}
              <nav className="categ-navbar">
                <ul className="categ-nav-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/shop">Shop</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                  <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                  <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                </ul>
              </nav>
            </div>
            <div className="categ-cart-user">
              <Link to="/your-cart"><img className="categ-cart" src={cart1} alt="#" loading="lazy"/></Link>
              <div className="shopDropdown">
                  <img className="categ-user" src={user?user.avatar:user1} alt="#" loading="lazy" onClick={toggleUser}/>
                  {isDropdownOpen&&(
                      <div className="shop-dropdownMenu" ref={dropdownRef}>
                          {user?(
                              <>
                                  <p className="shop-dropdownItem">Welcome, {user.firstname}</p>
                                  <Link to="/profile" className="shop-dropdownItem">Profile</Link>
                                  <Link to="/setting" className="shop-dropdownItem">Setting</Link>
                                  <Link onClick={onLogout} className="shop-dropdownItem">Log Out</Link>
                              </>
                          ):(
                              <>
                                  <Link to="/login" className="shop-dropdownItem">Login</Link>
                                  <Link to="/register" className="shop-dropdownItem">Register</Link>
                              </>
                          )}
                      </div>
                  )}
              </div>
            </div>
          </div>
        </header>
        {/* <!-- Main Content Section --> */}
        <main className="categ-main">
          <section className="categ-wrapper-section">
            {/* <!-- Category Dropdown --> */}
            <div className="category-dropdown">
              <div>
                <Link to='/'>
                    <img className="categ-logo" src={logo} alt="MoodMeals Logo"/>
                </Link>
              </div>
              <div className="categ-search">
                <label>Shop</label>
                <div className="categ">
                  <label for="categories">Categories</label>
                  <select id="categories" className="glass-select">
                    <option value="all">All</option>
                    <option value="comfort">Comfort</option>
                    <option value="energize">Energize</option>
                    <option value="focus">Focus</option>
                    <option value="relaxation">Relax</option>
                  </select>
                </div>
                {/* <!-- Search Bar --> */}
                <div className="search-bar">
                  <input type="text" value={searchQuery} onChange={(e)=>setSearchQuery(e.target.value)} placeholder="Search mood meals products, emotions, or moods"/>
                  <button onClick={handleSearch}>Search</button>
                </div>
              </div>
            </div>
            <h1>Happiness Meals and Snacks</h1>
            {/* <!-- Meals Grid --> */}
            <section className="meal-grid">
              {filteredProducts.map((element,index)=>(
                <article className="meal-item" key={index}>
                  <Link to={"/"+element.prod_name+"/"+element._id} className='Link'>
                    <img src={`https://moodmeals-theta.vercel.app${element.prod_img}`} alt={`Product ${index}`} loading="lazy"/>
                  </Link>
                  <h3>{element.prod_name}</h3>
                  <div className="meal-info">
                    <p>₱ {element.prod_price}</p>
                    <h4>{element.prod_rating}</h4>
                    <div className="meal-button">
                      <button className="categ-buyNow" onClick={(e)=>handleBuyNow(
                        e,
                        element._id,
                        element.prod_img,
                        element.prod_name,
                        element.prod_price
                      )}>Buy Now</button>
                      <button className="categ-add-to-cart" onClick={(e)=>handleAddToCart(
                        e,
                        element._id,
                        element.prod_img,
                        element.prod_name,
                        element.prod_price
                      )}>Add to Cart</button>
                    </div>
                  </div>
                </article>
              ))}
            </section>
          </section>
        </main>

        {/* <!-- Footer Section --> */}
        <Element name="contact">
          <footer className="categ-footer">
              <h3 className="categ-get-in-touch">Get in Touch</h3>
              <div className="categ-footer-content">
                  <div className="categ-footer-section">
                      <h3>Customer Support</h3>
                      <p>Email: <a href="/">support@moodmeals.com</a></p>
                      <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                      <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                      <h3>General Inquiries:</h3>
                      <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                      <h3>Partnership Opportunities:</h3>
                      <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
                  </div>
                  <div className="categ-footer-section">
                      <h3>Quick Links</h3>
                      <ul>
                          <li><Link to="/">Home</Link></li>
                          <li><Link to="/shop">Shop</Link></li>
                          <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                          <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                          <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                          <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                          <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                      </ul>
                  </div>
                  <div className="categ-footer-section">
                      <h3>Customer Services</h3>
                      <ul>
                          <li><a href="#contact-us">Contact Us</a></li>
                          <li><a href="#faq">FAQ</a></li>
                          <li><a href="#shipping&returns">Shipping & Returns</a></li>
                          <li><a href="#terms&condition">Terms & Condition</a></li>
                          <li><a href="#privacy">Privacy Policy</a></li>
                      </ul>
                  </div>
              </div>
              <div className="categ-soc-med">
                  <div className="categ-app-wrapper">
                      <img className="app" src={facebook} alt="facebook"/>
                      <img className="app" src={instagram} alt="instagram"/>
                      <img className="app" src={twitter} alt="twitter"/>
                      <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
                  </div>
                  <div className="categ-copyright">
                      <p>&copy; 2024 MoodMeals. All rights reserved.</p>
                  </div>
              </div>
          </footer>
        </Element>
      </>
      )}
    </>
  )
}

export default CategoryPage;